import PropTypes from 'prop-types';

export const filterResultShape = PropTypes.shape({
  filter: PropTypes.string,
  passed: PropTypes.bool,
  reason: PropTypes.string,
  relaxed: PropTypes.bool
});

export const phaseShape = PropTypes.shape({
  passed: PropTypes.bool,
  results: PropTypes.arrayOf(filterResultShape)
});

export const teacherEvalShape = PropTypes.shape({
  teacher_id: PropTypes.number,
  teacher_uuid: PropTypes.string,
  name: PropTypes.string,
  gender: PropTypes.string,
  profile_photo: PropTypes.string,
  slug: PropTypes.string,
  phase_a: phaseShape,
  phase_b: phaseShape,
  goals_matched: PropTypes.arrayOf(PropTypes.string),
  matched_goals: PropTypes.number,
  total_goals: PropTypes.number,
  goal_score_x10: PropTypes.number,
  days_available: PropTypes.number,
  repeat_available: PropTypes.bool,
  avail_score_x10: PropTypes.number,
  fit_score: PropTypes.number,
  finished_trials: PropTypes.number,
  finished_trials_source: PropTypes.string,
  points_balance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  effective_points_x100: PropTypes.number,
  points_decile: PropTypes.number,
  retention_score_x100: PropTypes.number,
  retention_is_platform_avg: PropTypes.bool,
  retention_decile: PropTypes.number,
  created_date: PropTypes.string,
  profile_live_at: PropTypes.string,
  live_date: PropTypes.string,
  rank: PropTypes.number,
  decided_by: PropTypes.string,
  shown_status: PropTypes.string,
  reason: PropTypes.string
});

export const studentShape = PropTypes.shape({
  id: PropTypes.number,
  uuid: PropTypes.string,
  email: PropTypes.string,
  name: PropTypes.string,
  timezone: PropTypes.string,
  timezone_is_fallback: PropTypes.bool,
  gender: PropTypes.string,
  country_iso: PropTypes.string,
  ethnicity: PropTypes.string,
  is_prenatal: PropTypes.bool,
  is_referral: PropTypes.bool,
  is_trial: PropTypes.bool,
  is_member: PropTypes.bool,
  is_test_user: PropTypes.bool,
  goals: PropTypes.arrayOf(
    PropTypes.shape({
      student_goal_id: PropTypes.number,
      display_name: PropTypes.string,
      is_health: PropTypes.bool,
      required_flag: PropTypes.string
    })
  ),
  teacher_gender_preference: PropTypes.string,
  gender_pref_inferred: PropTypes.bool
});

export const filtersShape = PropTypes.shape({
  phase_a: PropTypes.arrayOf(PropTypes.string),
  phase_b_hard: PropTypes.arrayOf(PropTypes.string),
  phase_b_soft_active: PropTypes.arrayOf(PropTypes.string),
  relaxed: PropTypes.arrayOf(PropTypes.string),
  pool_after_phase_a: PropTypes.number,
  pool_after_phase_b: PropTypes.number
});

export const slotShape = PropTypes.shape({
  start_epoch: PropTypes.number,
  student_local: PropTypes.string,
  epochs_14d: PropTypes.arrayOf(PropTypes.number)
});

export const overridesShape = PropTypes.shape({
  goals: PropTypes.arrayOf(PropTypes.string),
  teacher_gender_preference: PropTypes.string,
  student_gender: PropTypes.string,
  student_ethnicity: PropTypes.string,
  country_iso: PropTypes.string,
  is_referral_student: PropTypes.string,
  is_prenatal_student: PropTypes.string,
  disable_thin_pool_relaxation: PropTypes.bool
});

export const funnelShape = PropTypes.shape({
  text: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      filter: PropTypes.string,
      label: PropTypes.string,
      before: PropTypes.number,
      removed: PropTypes.number,
      remaining: PropTypes.number,
      failing: PropTypes.number,
      relaxed: PropTypes.bool
    })
  )
});
